import React, { useState, useEffect } from 'react';
import Navbar from './navbar';
import AboutUs from './AboutUs/AboutUs';
import OurTeachers from './OurTeachers/OurTeachers';
import OurSchool from './OurSchool/OurSchool';
import Footer from './footer';
import "./IndexBackground.css";
// Import image from assets folder inside src
import backgroundImage from '../assets/RealEnglishImages/RealEnglishLamb3.png';
import BilingualProject from './BilingualProject/BilingualProject';
import Reviews from './Reviews/Reviews';
import { Navigate, Route, Routes } from 'react-router-dom';
import Gallery from './Gallery/Gallery';
import HomePage from './HomePage/HomePage';
import Awards from './Awards/Awards';
// Import Google Fonts

const IndexRoute = () => {
    document.title = "Real English";

    // Scroll function to show "back to top" button
    const scrollFunction = () => {
        const element = document.getElementById("back-to-top");
        if (element) {
            if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
                element.style.display = "block";
            } else {
                element.style.display = "none";
            }
        }
    };

    window.onscroll = function () {
        scrollFunction();
    };

    const toTop = () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    };

    // Track screen size for responsive design
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 576); // 576px breakpoint for mobile
        };

        handleResize(); // Check screen size initially
        window.addEventListener('resize', handleResize); // Update screen size on window resize

        return () => window.removeEventListener('resize', handleResize); // Cleanup listener on unmount
    }, []);

    // Default background style (applied for larger screens)
    const backgroundStyle = {
        backgroundImage: `url(${backgroundImage})`,  // Using the imported background image
        backgroundSize: '70%',
        backgroundPosition: 'center 100%',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        minHeight: '100vh',
        width: '100%',
        overflowX: 'hidden',
    };

    // Mobile-specific background style (applied for small screens)
    const mobileBackgroundStyle = {
        ...backgroundStyle,
        backgroundSize: '100%',
        backgroundPosition: 'center 60%',
    };

    // Choose the appropriate style based on screen size
    const appliedBackgroundStyle = isMobile ? mobileBackgroundStyle : backgroundStyle;

    return (
        <React.Fragment>
            <div > 
              
                <div className="pt-5" style={{ ...appliedBackgroundStyle,backgroundColor: "rgba(245, 237, 237, 0.85)"}}
                >
                    <div style={{backgroundColor: "rgba(245, 237, 237, 0.85)",
                        maxWidth: "",
                        minHeight:"100vh",
                        margin: "0 auto",
                        position: "relative",}}>

                        <Navbar />
                        <Routes>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/AboutUs" element={<AboutUs />} />
                            <Route path="/OurTeachers" element={<OurTeachers />} />
                            <Route path="/OurSchool" element={<OurSchool />} />
                            <Route path="/BilingualProject" element={<BilingualProject />} />
                            <Route path="/Reviews" element={<Reviews />} />
                            <Route path="/Gallery" element={<Gallery />} />
                            <Route path="/HomePage" element={<HomePage/>} />
                            <Route path="/ELT-ExcellenceAwards" element={<Awards/>} />
                            
                            <Route path="*" element={<Navigate to="/" />} />
                        </Routes>
                    </div>
                </div>

                <Footer />
                <button onClick={toTop} className="btn btn-danger btn-icon landing-back-top" id="back-to-top">
                    <i className="ri-arrow-up-line"></i>
                </button>
            </div>
        </React.Fragment>
    );
};

export default IndexRoute;
